import * as React from "react";
import { connect } from "react-redux";
import { Person } from "@radivision/graphql/lib/ts/graphql/person";
import { Entity } from "@radivision/graphql/lib/ts/graphql/entity";
import { OriginalContentStory } from "@radivision/graphql/lib/ts/graphql/original-content-story";
import isEmpty from "lodash.isempty";
import { NotifyMeForm } from "./notify-me-form";
import { isOwner } from "../../../../utilities/is-owner";

interface ComponentProps {
  entity: Entity;
  item: OriginalContentStory;
}
interface MapStateProps {
  user: Person | null;
}
type Props = ComponentProps & MapStateProps;
interface State {
  investor: string;
}
class InvestmentNotificationFormComponent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { investor: "" };
  }

  render() {
    const { entity, user } = this.props;
    const companyOwner = isOwner(entity, user);
    const companyHasPitchVideo = entity?.pitchOriginalMedia?.id;
    const opportunities = entity?.opportunities;
    const hasAnyOpportunities =
      !isEmpty(opportunities?.productAndServices?.description) ||
      !isEmpty(opportunities?.careers?.description) ||
      !isEmpty(opportunities?.collaboration?.description) ||
      !isEmpty(opportunities?.productAndServices?.link) ||
      !isEmpty(opportunities?.careers?.link) ||
      !isEmpty(opportunities?.collaboration?.link) ||
      !isEmpty(opportunities?.productAndServices?.email) ||
      !isEmpty(opportunities?.careers?.email) ||
      !isEmpty(opportunities?.collaboration?.email);

    if (companyHasPitchVideo || hasAnyOpportunities) {
      return null;
    }

    const viewerMessage = !isEmpty(entity) && !companyOwner && !companyHasPitchVideo;
    const ownerMessage = !isEmpty(entity) && companyOwner && !hasAnyOpportunities;

    if (ownerMessage) {
      return null;
      // <Container>
      //   <h2 className="no-content">
      //     Your company's profile is missing its opportunities information.
      //     <br />
      //     You can use "Edit Profile" button to add this important information that viewers want to see to learn more
      //     about your company, Thank you!
      //   </h2>
      // </Container>
    }

    if (viewerMessage) {
      return (
        <Container>
          <h2 className="no-content">
            &rdquo;{entity.name}&ldquo; has not posted their opportunities information yet.
            <br />
            If you would like to let them know you are interested, provide your email address for us to forward directly
            to the company. Thank you!
          </h2>
          <NotifyMeForm entity={entity} />
        </Container>
      );
    }
    return null;
  }
}

const mapState = (state: AppState) => ({
  user: state.account.user,
});
export const InvestmentNotificationForm = connect(mapState)(InvestmentNotificationFormComponent);
const Container = ({ children }) => {
  return <div className="investment-notification-form">{children}</div>;
};
